"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var BriefcaseActions = require("@caddigital/sok-reducers/lib/actions/briefcase/current");
var BidRouter_1 = require("./BidRouter");
var BriefcaseView_1 = require("views/BriefcaseView");
var BidListView_1 = require("views/BidListView");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var index_1 = require("../../views/admin/Activity/index");
require("./style.scss");
var mapStateToProps = function (state) { return ({
    briefcase: state.briefcase.current.briefcase,
    status: state.briefcase.current.status
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (id) { return dispatch(BriefcaseActions.fetchRequest(id)); },
    clear: function () { return dispatch(BriefcaseActions.clear()); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        if (this.props.status === 'STANDBY') {
            var id = parseInt(this.props.match.params.id, 10);
            if (this.props.briefcase === null || id !== this.props.briefcase.id) {
                this.props.fetch(id);
            }
        }
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.status !== prevProps.status) {
            if (this.props.status === 'STANDBY') {
                var id = parseInt(this.props.match.params.id, 10);
                if (this.props.briefcase === null || id !== this.props.briefcase.id) {
                    this.props.fetch(id);
                }
            }
        }
        else if (this.props.status === 'FETCHED' &&
            this.props.match.params.id !== prevProps.match.params.id) {
            var id = parseInt(this.props.match.params.id, 10);
            this.props.fetch(id);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    if (props.status === 'FETCHING') {
        return (React.createElement("div", { className: 'briefcase-router-loading' },
            React.createElement("div", null,
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    else if (props.status === 'FAILED' || props.briefcase === null) {
        return (React.createElement("div", { className: 'briefcase-router-error' },
            React.createElement(GenericErrorMessage_1.default, null)));
    }
    var currentBriefcase = props.briefcase;
    var baseUrl = props.match.path;
    return (React.createElement(react_router_dom_1.Switch, null,
        React.createElement(react_router_dom_1.Route, { exact: true, key: 'home', path: baseUrl + "/", render: function (props) { return (React.createElement(BriefcaseView_1.default, __assign({}, props, { currentBriefcase: currentBriefcase }))); } }),
        React.createElement(react_router_dom_1.Route, { key: 'bid-router', path: baseUrl + "/bid/:bid?/(letter)?/:letterId?/(files)?/:folderId?", render: function (props) {
                return (React.createElement(BidRouter_1.default, __assign({}, props, { currentBriefcase: currentBriefcase, baseUrl: baseUrl + '/bid/:bid?' })));
            } }),
        React.createElement(react_router_dom_1.Route, { exact: true, key: 'bids', path: baseUrl + "/bids", render: function (props) { return (React.createElement(BidListView_1.default, __assign({}, props, { currentBriefcase: currentBriefcase }))); } }),
        React.createElement(react_router_dom_1.Route, { key: 'activities', path: "".concat(baseUrl, "/activity"), component: index_1.default })));
});
